import { render, staticRenderFns } from "./CommitteeMemberCreate.vue?vue&type=template&id=4cfde470&scoped=true"
import script from "./CommitteeMemberCreate.vue?vue&type=script&lang=js"
export * from "./CommitteeMemberCreate.vue?vue&type=script&lang=js"
import style0 from "./CommitteeMemberCreate.vue?vue&type=style&index=0&id=4cfde470&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfde470",
  null
  
)

export default component.exports